import { getConsultsForPatient } from 'api/consult/getConsultsForPatient';
import { GlobalHeader } from 'components/_global/header/GlobalHeader';
import { BodyNoNav } from 'components/structure/body';
import { useBrowserContext } from 'contexts/BrowserContext';
import { ConsultProvider } from 'contexts/ConsultContext';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { useQueryParams } from 'hooks/useQueryParams';
import { FC, useState } from 'react';

import ScheduleFirstAppointment from '../consult/appointments/ScheduleFirstAppointmentPage';

const NpScheduleFirstAppointment: FC = () => {
  const user = useCurrentUser();
  const { isMobileView } = useBrowserContext();
  const { getParam } = useQueryParams();
  const memberId = getParam('memberId');
  const [consultId, setConsultId] = useState<string | undefined>(undefined);
  getConsultsForPatient(memberId).then((consults: { id: string }[]) => {
    if (consults.length > 0) {
      setConsultId(consults[0].id);
    }
  });
  if (!memberId) {
    return <></>;
  }
  if (!consultId) {
    return <></>;
  }
  return (
    <ConsultProvider consultId={consultId as string}>
      <GlobalHeader user={user.state.account} isMobileView={isMobileView} />
      <BodyNoNav>
        <ScheduleFirstAppointment selfNpReferFlow={true} memberId={memberId} />
      </BodyNoNav>
    </ConsultProvider>
  );
};

export default NpScheduleFirstAppointment;
